import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  amountWithCurrencySymbol,
  DEFAULT_CURRENCIES,
} from '@/helpers/currency';
import { showTooltip } from '@/helpers/tooltip';
import { getCurrencyCentsAndCode } from '@/helpers/wallet';
import { useGetCommonStore } from '@/store';
import { TooltipTypes } from '@/store/tooltipStore';

export const usePaymentNotification = () => {
  const { t } = useTranslation();
  const useCommonStore = useGetCommonStore();
  const playerPayments = useCommonStore.use.playerPayments();

  useEffect(() => {
    if (playerPayments.length === 0) return;

    const lastPayment = playerPayments[playerPayments.length - 1];

    if (!lastPayment.success) return;

    const { currency, amount } = getCurrencyCentsAndCode(
      lastPayment.amountCents,
      lastPayment.currency,
      DEFAULT_CURRENCIES
    );

    showTooltip({
      type: TooltipTypes.SUCCESS,
      body: t('paymentSuccessful', {
        amount: amountWithCurrencySymbol(currency, amount),
      }),
    });
  }, [playerPayments, t]);
};
